import { API_SYSTEM_GET_SYSTEMCONFIG, API_SYSTEM_CONFIG_BASEINFO, API_SYSTEM_RELOAD_CROSSFORM_RELATION_DATA, API_SYSTEM_DELETE_ALL_TEMPTABLE,
    API_COMPANY_ADD_CONFIGRESOURCE, API_COMPANY_LIST, API_COMPANY_DELETE, API_SYSTEM_LOAD_DASHBOARD_IN_CACHE, API_SYSTEM_SYNC_FORMDATA_CACHE,
    API_COMPANY_DETAIL, API_COMPANY_SAVE, API_COMPANY_UPLOAD, API_COMPANY_CHANGE_AUDITSTATE, API_MY_COMPANY_DETAIL,
    API_SYSTEM_CLEANREDISCACHE, API_SYSTEM_CLEANFORMDATA, API_SYSTEM_UPD_APPROVAL_SUCCESS_INFO, API_SYSTEM_SELECTCACHEBITABLES, API_SYSTEM_DELETETEMPTABLE,
    API_SYSTEM_SETFORMDATAREDISMODE, API_SYSTEM_SYNC_APPROVE_DATE, API_SYSTEM_UPDUSERREFDATA
} from '@/common/constants';
import { get, post, del, put } from '@/utils/http';

export const getCompanyList = (currentPage = 1, pageSize = 10, keyWord) => {
    return get(API_COMPANY_LIST, { currentPage, pageSize, companyName: keyWord });
};

export const getCompanyDetail = (companyId) => {
    return get(API_COMPANY_DETAIL.replace(':companyId', companyId));
};

export const getMyCompanyDetail = () => {
    return get(API_MY_COMPANY_DETAIL);
};

export const delCompany = (companyId) => {
    return del(API_COMPANY_DELETE.replace(':companyId', companyId));
};

export const saveCompany = (company) => {
    if (company.id === undefined || company.id === '') {
        return post(API_COMPANY_SAVE, company);
    } else {
        return put(API_COMPANY_SAVE, company);
    }
};

export const updCompany = (company) => {
    return put(API_COMPANY_SAVE, company);
};

export const updloadImg = (fileForm) => {
    return post(API_COMPANY_UPLOAD, {'fileName': fileForm.fileName, 'filePath': fileForm.filePath, 'fileByteSize': fileForm.fileByteSize, 'fileType': fileForm.fileByteSize});
};

export const changeCompanyAuditState = (id, auditState) => {
    return post(API_COMPANY_CHANGE_AUDITSTATE, { 'id': id, 'auditState': auditState });
};

export const configResource = (id) => {
    return post(API_COMPANY_ADD_CONFIGRESOURCE, { 'id': id });
};

export const getSystemConfig = () => {
    return get(API_SYSTEM_GET_SYSTEMCONFIG);
};

export const configSystemBaseInfo = (param) => {
    return post(API_SYSTEM_CONFIG_BASEINFO, param);
};

export const loadDashBoardInCache = (param) => {
    return post(API_SYSTEM_LOAD_DASHBOARD_IN_CACHE, param);
};

export const syncFormDataCache = (param) => {
    return post(API_SYSTEM_SYNC_FORMDATA_CACHE, param);
};

export const cleanRedisCache = (param) => {
    return post(API_SYSTEM_CLEANREDISCACHE, param);
};
export const cleanFormData = (param) => {
    return post(API_SYSTEM_CLEANFORMDATA, param);
};
export const updUserRefData = (param) => {
    return post(API_SYSTEM_UPDUSERREFDATA, param);
};
export const updApprovalSuccessInfo = (param) => {
    return post(API_SYSTEM_UPD_APPROVAL_SUCCESS_INFO, param);
};
export const setFormDataRedisMode = (param) => {
    return post(API_SYSTEM_SETFORMDATAREDISMODE, param);
};

export const selectCacheBITablesInfo = (param) => {
    return post(API_SYSTEM_SELECTCACHEBITABLES, param);
};

export const deleteTempTable = (param) => {
    return post(API_SYSTEM_DELETETEMPTABLE, param);
};
export const deleteAllTempTable = (param) => {
    return post(API_SYSTEM_DELETE_ALL_TEMPTABLE, param);
};

export const reloadCrossFormRelationData = (param) => {
    return post(API_SYSTEM_RELOAD_CROSSFORM_RELATION_DATA, param);
};

export const syncApproveDate = (param) => {
    return post(API_SYSTEM_SYNC_APPROVE_DATE, param);
};



// WEBPACK FOOTER //
// ./src/data-model/system/company-model.js